module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "items-list",
    class: {
      inner: _vm.isInnerList
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('div', [_c('a', {
      staticClass: "card-link",
      attrs: {
        "title": item.name
      },
      on: {
        "click": function($event) {
          _vm.setCurrentItem(item, $event)
        }
      }
    }, [_c('b-card', {
      staticClass: "individual-item",
      attrs: {
        "no-body": "",
        "bg-variant": _vm.isCurrentItem(item) ? 'light' : '',
        "border-variant": _vm.isCurrentItem(item) ? 'primary' : 'light'
      }
    }, [_c('p', {
      staticClass: "card-text"
    }, [(item.type.endsWith('requirement')) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedRequirements),
        expression: "selectedRequirements"
      }],
      staticClass: "prevent-this-click",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item,
        "checked": Array.isArray(_vm.selectedRequirements) ? _vm._i(_vm.selectedRequirements, item) > -1 : (_vm.selectedRequirements)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selectedRequirements,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedRequirements = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedRequirements = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedRequirements = $$c
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('icon', {
      class: _vm.getIconClass(item),
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "name": item.type === 'requirement' ? 'file-text-o' : 'folder-o'
      }
    }), _vm._v(" "), (item.type === 'requirement') ? _c('span', {
      staticClass: "my-card-text listview-item-id"
    }, [_vm._v(_vm._s(item.prefix + _vm.getID(item)))]) : _c('span', {
      staticClass: "my-card-text listview-item-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.has_descendant_folders || item.has_descendant_requirements) ? _c('span', {
      on: {
        "click": function($event) {
          _vm.toggle(item)
        }
      }
    }, [_c('icon', {
      staticClass: "prevent-this-click",
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "name": _vm.isExpandedFolder(item) ? 'minus-square-o' : 'plus-square-o'
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type === 'requirement') ? _c('span', [_c('br'), _vm._v(" "), _c('span', {
      staticClass: "my-card-text listview-item-name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()], 1)])], 1), _vm._v(" "), (item.descendants) ? _c('items-list', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.openFolderIds && _vm.openFolderIds.hasOwnProperty(item.folder_id)),
        expression: "openFolderIds && openFolderIds.hasOwnProperty(item.folder_id)"
      }],
      attrs: {
        "items": item.descendants,
        "selectedRequirements": _vm.selectedRequirements,
        "isInnerList": "true"
      }
    }) : _vm._e()], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0abe4e7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemsList.vue
// module id = 996
// module chunks = 1